import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "./api";

const AuthCtx = createContext(null);
export const ADMIN_ROLES = ["super_admin", "operations_admin", "survey_manager", "finance_manager", "compliance_reviewer", "support_agent", "auditor"];

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);
  useEffect(() => {
    // If returning from Google OAuth callback, AuthCallback exchanges the session_id first.
    if (window.location.hash?.includes("session_id=")) {
      setUser(null);
      return;
    }
    refresh();
  }, [refresh]);
  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.error("Logout request failed:", e);
    }
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, setUser, refresh, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export function RequireAuth({ admin = false, children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="auth-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#2563EB] border-t-transparent" />
      </div>
    );
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  const isAdmin = ADMIN_ROLES.includes(user.role);
  if (admin && !isAdmin) return <Navigate to="/app" replace />;
  if (!admin && isAdmin) return <Navigate to="/admin" replace />;
  return children;
}
